const promotionTypeMapping: Record<string, string> = {
  '1+1': 'oneforone',
}

export { promotionTypeMapping }
